import axios from 'axios'
import qs from 'qs'
import Store from 'store'
import Loading from 'dmx/directives/dmx-loading'
import { MINI_TIME, TIME_OUT_MAX } from '@/config/api'
import Vue from 'vue'
import { getCaller } from '@/utils/tools'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// 请求队列
let _request = []

let loadingInstance = null

// 向队列中添加请求
const pushRequest = config => {
        // console.log(`${config.url} -- 开始`)
        _request.push(config)
    }
    // 从队列中移除请求 
const popRequest = config => {
    // console.log(`${config.url} -- 结束`)
    let _index = _request.findIndex(r => {
        return r === config
    })
    if (_index > -1) {
        _request.splice(_index, 1)
    }
    if (_request.length <= 0) {
        setTimeout(() => {
            if (loadingInstance) {
                loadingInstance.close()
                loadingInstance = null
            }
        }, MINI_TIME)
    }
}
class Service {
    constructor(opt = {
        baseURL: '/walletapi',
        url: '',
        method: 'get',
        data: {},
        needLoading: true,
        needToken: true
    }) {
        let needLoading = opt.needLoading
        if (needLoading !== false) {
            loadingInstance = Loading.service()
        }
        let _url = opt.url
        let _config = Object.assign({
            baseURL: '/walletapi'
        }, opt, {
            timeout: TIME_OUT_MAX,
            headers: {
                'caller': getCaller(),
                'x-h5': 'loan',
                'x-device-info': decodeURIComponent(Vue.cookie('deviceInfo')) || 'H5/0/touch/7060000/5',
                'channel': Vue.cookie('partner') || 'H5_WALLET',
                'channel2': Vue.cookie('channel') || '',
                'portal': Vue.cookie('portal') || '',
                'vue-router-base': Store.get('vue-router-base') || '/',
                'jm-authorization': opt.needToken === false ? '' : (Store.get('token') || '')
            },
            responseType: 'json',
            responseEncoding: 'utf8'
        })
        const _instance = axios.create(_config)
        let formData = Object.assign({}, opt.data)
        formData = qs.stringify(formData)
        if ((opt.method || 'get') === 'get' && formData) {
            _url = [_url, '?', formData].join('')
        }

        return new Promise((resolve, reject) => {
            let _random = {
                timestamp: Date.now(),
                url: _url,
                needLoading: needLoading
            }
            pushRequest(_random)
            _instance({
                    url: _url,
                    method: opt.method || 'get',
                    data: formData
                })
                .then(res => {
                    let responseData = res.data
                    if ((responseData.statusCode || responseData.status) == 200) {
                        if (typeof responseData.data === 'string') {
                            let data = responseData.data
                            try {
                                data = JSON.parse(data)
                            } catch (e) {
                                // empty block
                            }
                            responseData.data = data
                        }
                        popRequest(_random)
                        resolve(responseData.data)
                    } else {
                        if ((responseData.statusCode || responseData.status) == 401) {
                            // Store.remove('token')
                            setTimeout(() => {
                                let baseUrl = Store.get('vue-router-base') || '/'
                                baseUrl = baseUrl == '/' ? '' : baseUrl
                                if (window.location.href.indexOf('/login') == -1) {
                                    window.location.href = baseUrl + '/login'
                                }
                            }, 0)
                        }
                        popRequest(_random)
                        reject({
                            status: (responseData.statusCode || responseData.status),
                            message: (responseData.errorMessage || responseData.message)
                        })
                    }
                })
                .catch(res => {
                    let _response = res.response
                    popRequest(_random)
                    reject({
                        status: _response.status,
                        message: _response.body || _response.data || _response.statusText || 'unknow'
                    })
                })
        })
    }
}

export class LoanService {
    constructor(opt = {
        url: '',
        method: 'get',
        data: {},
        needLoading: true
    }) {
        var _server = new Service(opt)
        return new Promise((resolve, reject) => {
            _server.then(result => {
                if (result.status === 200) {
                    resolve(result.data)
                } else {
                    reject(result)
                }
            }).catch(err => {
                reject({
                    status: err.status || 500,
                    message: err.message
                })
            })
        })
    }
}

export class AuthService {
    constructor(opt = {
        url: '',
        method: 'get',
        data: {},
        needLoading: true
    }) {
        return new Service(Object.assign({}, opt, {
            baseURL: '/auth'
        }))
    }
}

export default Service